import { connect } from 'react-redux'
import Teachers from './teachers'
import {
  getFetchSchoolTeamRequest,
  getTeachersList,
  isSchoolAPobbleSchool
} from '../../../../../stores/school-team/school-team.selectors'
import { getGroupSubCheckoutUrl } from '../../../../../stores/school-team/school-team.actions'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { me, meRequest }) => {
  return {
    pending: getFetchSchoolTeamRequest(state).pending,
    teachers: getTeachersList(state) || [],
    groupSubId:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons[0] &&
      me.account.all_my_subscriptions_group_addons[0].subscriptions_group.id,
    ownedGroupSub:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons[0] &&
      me.account.all_my_subscriptions_group_addons.filter(
        addon => !addon.addon_delegated
      )[0],
    totalOfGroupSubs:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons.length,
    nbOfGroupSubs:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons[0] &&
      me.account.all_my_subscriptions_group_addons.filter(
        addon => !addon.assigned_to_account_id
      ).length,
    expiry:
      !meRequest.pending &&
      me &&
      me.account.all_my_subscriptions_group_addons &&
      me.account.all_my_subscriptions_group_addons[0] &&
      me.account.all_my_subscriptions_group_addons[0].subscriptions_group
        .period_end,
    schoolHasSubAlready: isSchoolAPobbleSchool(state),
    canSeeGroupSeatsOptions:
      !meRequest.pending &&
      me &&
      me.account.policy &&
      me.account.policy.can_see_group_seats_options
  }
}

const mapDispatchToProps = dispatch => ({
  onBuyGroupSub: id =>
    dispatch(getGroupSubCheckoutUrl(id))
      .then(res => (window.location = res.data.url))
      .catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Teachers)
)
